// === New Home Page Insight Cards (Phase 14) ===

export interface HomeInsightCard {
	id: string;
	titleKey: string;
	descriptionKey: string;
	illustration: string;
	backgroundColor: string;
	route?: string;
}

export const HOME_INSIGHTS: HomeInsightCard[] = [
	{
		id: "files",
		titleKey: "home.evesInsights.files.title",
		descriptionKey: "home.evesInsights.files.description",
		illustration: "/images/home/insights/files-insights.png",
		backgroundColor: "#EFF0FB",
		route: "/files",
	},
	{
		id: "prepare",
		titleKey: "home.evesInsights.prepare.title",
		descriptionKey: "home.evesInsights.prepare.description",
		illustration: "/images/home/insights/prepare-insights.png",
		backgroundColor: "#FFF2FC",
		route: "/get-ready",
	},
	{
		id: "track",
		titleKey: "home.evesInsights.track.title",
		descriptionKey: "home.evesInsights.track.description",
		illustration: "/images/home/insights/track-insights.png",
		backgroundColor: "#FFF8F0",
		route: "/track",
	},
];

// === Legacy Card Types (used by ChatContainer/ChatPage) ===

export interface InsightActionCard {
	id: string;
	type: "action";
	textKey: string;
	icon: "questionnaire" | "upload";
	action?: string;
}

export interface InsightInfoCard {
	id: string;
	type: "info";
	textKey: string;
	action?: string;
}

export type InsightCard = InsightActionCard | InsightInfoCard;

export const MOCK_INSIGHTS: InsightCard[] = [
	{
		id: "action-questionnaire",
		type: "action",
		textKey: "evesInsights.cards.completeQuestionnaire",
		icon: "questionnaire",
	},
	{
		id: "action-upload",
		type: "action",
		textKey: "evesInsights.cards.uploadRecords",
		icon: "upload",
		action: "/documents",
	},
	{
		id: "info-visit-reminder",
		type: "info",
		textKey: "evesInsights.cards.visitReminder",
	},
	{
		id: "info-questionnaire-reminder",
		type: "info",
		textKey: "evesInsights.cards.questionnaireReminder",
	},
];
